import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2e0e2bab&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./assets/css/fonts-latin-extended.min.css?vue&type=style&index=0&id=2e0e2bab&scoped=true&lang=css&"
import style1 from "./assets/css/nissan_base.css?vue&type=style&index=1&id=2e0e2bab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0e2bab",
  null
  
)

export default component.exports